import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { fetchMyApps, type UserApp } from '../api/launcherApi'
import { getErrorMessage } from '../api/client'
import { SYSTEM_APP_IDS } from '@paperair/shared-types'

interface LauncherState {
  apps: UserApp[]
  isLoading: boolean
  error: string | null
  lastOpenedAppId: string | null

  fetchApps: () => Promise<void>
  // Sets lastOpenedAppId and routes to the right place.
  // For external apps, navigates to /redirect which performs the handoff.
  launchApp: (appId: string, navigate: (path: string) => void) => void
}

export const useLauncherStore = create<LauncherState>()(
  persist(
    (set) => ({
      apps: [],
      isLoading: false,
      error: null,
      lastOpenedAppId: null,

      fetchApps: async () => {
        set({ isLoading: true, error: null })
        try {
          const apps = await fetchMyApps()
          set({ apps, isLoading: false })
        } catch (error) {
          set({ isLoading: false, error: getErrorMessage(error) })
        }
      },

      launchApp: (appId: string, navigate: (path: string) => void) => {
        set({ lastOpenedAppId: appId })

        if (appId === SYSTEM_APP_IDS.AUTH_ADMIN) {
          navigate('/dashboard')
          return
        }

        navigate('/redirect')
      },
    }),
    {
      name: 'launcher-storage',
      partialize: (state) => ({ lastOpenedAppId: state.lastOpenedAppId }),
    }
  )
)
